import { render, staticRenderFns } from "./StudyProgramGroupAdd.vue?vue&type=template&id=7a746322&"
import script from "./StudyProgramGroupAdd.vue?vue&type=script&lang=js&"
export * from "./StudyProgramGroupAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports